import styled from 'styled-components';
import { PaddingMain } from '../../style/commonStyle';

export const ProfileModifyMain = styled(PaddingMain)`
padding-top: 110px;
`
